<template>
  <OringAssistantStepCards :cards="cards" />
</template>

<script setup lang="ts">
import OringAssistantStepCards from './OringAssistantStepCards.vue'
import useI18nExtended from '~/composables/usei18nExtended'
import groovePng from '~/assets/images/InBore.png'
import grooveShaft from '~/assets/images/onShaft.png'
import {useORingCalculatorStore} from '@/store/oring-calculator'
import {storeToRefs} from 'pinia'

const i18n = useI18nExtended()
const store = useORingCalculatorStore()
const {oringAssistantOnShaft} = storeToRefs(store)

const cards = [
  {
    title: i18n.tv('Frontend.Title.RingMounting', 'ORingConfiguratorImport'),
    description: i18n.tv('Frontend.Message.RingMounting', 'ORingConfiguratorImport'),
    model: oringAssistantOnShaft,
    options: [
      {value: false, label: i18n.tv('Frontend.Application.MountingInBore', 'ORingConfiguratorImport'), imgUrl: groovePng},
      {value: true, label: i18n.tv('Frontend.Application.MountingOnShaft', 'ORingConfiguratorImport'), imgUrl: grooveShaft}
    ],
    popupContent: {title: i18n.tv('Frontend.Title.RingMounting', 'ORingConfiguratorImport'), content: i18n.tv('Frontend.Info.RingMountingOne', 'ORingConfiguratorImport')}
  }
]

</script>
